/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Converts a {@link Opaque} handle to the underlying branded type.
 *
 * It is assumed that only code that produces these "opaque" handles does this conversion,
 * allowing these handles to be considered opaque.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractFromOpaque(value) {
    return value;
}
/**
 * Adds a type {@link Brand} to a value, returning it as a {@link Opaque} handle.
 *
 * Only do this when specifically allowed by the requirements of the type being converted to.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function brandOpaque(value) {
    return value;
}
//# sourceMappingURL=opaque.js.map